var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"app-score-image",attrs:{"src":_vm.scoreImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }